import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_aqua-automation-6/artifacts/xhc56h1e_fe56aded-38ef-4918-806c-2e1721a85900.jpeg";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white">
      <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="inline-block bg-white p-3">
            <img
              src={LOGO_URL}
              alt="Aquamatic — Smart Wireless Water Management Automation"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </div>
          <p className="mt-4 max-w-md text-zinc-400 text-sm leading-relaxed">
            Smart wireless water level controllers &amp; pump automation for houses, factories,
            high-rise societies, malls, hospitals and government buildings.
          </p>
          <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            ISO 9001 • BIS Certified • CE Marked
          </div>
        </div>

        <FooterCol title="Company" items={["About", "Products", "Services", "Industries"]} />
        <FooterCol
          title="Reach us"
          items={[
            "Toll-free: 1800 891 2595",
            "aquamaticsales@gmail.com",
            "Plot 649, Ind. Area Phase IX,",
            "Mohali, SAS Nagar, Punjab",
          ]}
        />
      </div>
      <div className="border-t border-zinc-800 py-6 px-6 md:px-12 lg:px-24 flex flex-col md:flex-row items-center justify-between gap-2">
        <p className="text-xs text-zinc-500 font-mono uppercase tracking-widest">
          © {new Date().getFullYear()} Aquamatic Inc. All rights reserved.
        </p>
        <p className="text-xs text-zinc-500 font-mono uppercase tracking-widest">
          Made for water • Built to last
        </p>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-400 mb-4">
        {title}
      </div>
      <ul className="space-y-2 text-sm text-zinc-300">
        {items.map((i) => (
          <li key={i}>{i}</li>
        ))}
      </ul>
    </div>
  );
}
